import React, { memo } from 'react';
import { cn } from '@/utils';

export const RapidaIcon = memo((props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1080 214"
      fill="none"
      className={cn('w-5 h-5', props.className)}
      {...props}
    >
      <image
        href="/images/logos/icon-01.png"
        x="0"
        y="0"
        width="1080"
        height="214"
        preserveAspectRatio="xMidYMid meet"
      />
    </svg>
  );
});